import React from 'react';
import { CheckCircle } from 'lucide-react';
import { FadeIn } from './FadeIn';
const checklistItems = ['Sientes picazón constante, incluso después de lavarte el pelo.', "Notas descamación o 'caspa' que no desaparece con champús comerciales.", 'Tu cuero cabelludo se siente tenso, sensible o irritado.', 'Has probado múltiples productos y sientes que nada funciona a largo plazo.', 'Buscas una solución natural, dermatológica y libre de químicos agresivos.', 'Quieres entender por fin qué le pasa a tu piel y cómo cuidarla.'];
export function ChecklistSection() {
  return <section className="py-20 md:py-28 bg-white" data-id="element-1">
      <div className="max-w-4xl mx-auto px-4" data-id="element-2">
        <FadeIn className="text-center mb-16" data-id="element-3">
          <h2 className="font-serif text-3xl md:text-4xl text-warm-900 mb-4" data-id="element-4">
            Esto es para ti si...
          </h2>
          <div className="h-1 w-20 bg-sage-300 mx-auto rounded-full" data-id="element-5" />
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8" data-id="element-6">
          {checklistItems.map((item, index) => <FadeIn key={index} delay={index * 0.1} direction="up" data-id="element-7">
              <div className="flex items-start gap-4 p-4 rounded-xl hover:bg-sage-50 transition-colors duration-300" data-id="element-8">
                <CheckCircle className="w-6 h-6 text-sage-400 flex-shrink-0 mt-1" data-id="element-9" />
                <p className="text-warm-700 text-lg" data-id="element-10">{item}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}